function generateId(): string {
    if (typeof crypto !== "undefined" && typeof (crypto as any).randomUUID === "function") {
        return (crypto as any).randomUUID();
    }
    if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
        const bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);
        bytes[6] = (bytes[6] & 0x0f) | 0x40;
        bytes[8] = (bytes[8] & 0x3f) | 0x80;
        const hex: string[] = [];
        for (let i = 0; i < 256; i++) hex[i] = (i + 0x100).toString(16).slice(1);
        const b = bytes;
        return (
            hex[b[0]] + hex[b[1]] + hex[b[2]] + hex[b[3]] + "-" +
            hex[b[4]] + hex[b[5]] + "-" +
            hex[b[6]] + hex[b[7]] + "-" +
            hex[b[8]] + hex[b[9]] + "-" +
            hex[b[10]] + hex[b[11]] + hex[b[12]] + hex[b[13]] + hex[b[14]] + hex[b[15]]
        );
    }
    return `r-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

export function getOrCreateSessionId(key = "chatbot_session_id"): string {
    if (typeof window === "undefined") return `ssr-${generateId()}`; 
    let existing: string | null = null;
    try { existing = window.localStorage.getItem(key); } catch { }
    if (existing) return existing;
    const id = generateId();
    try { window.localStorage.setItem(key, id); } catch { }
    return id;
}
